<template>
  <v-text-field
    placeholder="Buscar por Email"
    flat
    solo
    prepend-icon="mdi-magnify"
    class="searchInput px-5 pt-1"
    v-model="search"
    @input="$emit('updateSearch', search)"
  ></v-text-field>
</template>

<script>
export default {
  data() {
    return {
      search: ""
    };
  }
};
</script>

<style scoped>
.searchInput {
  height: 56px;
  width: 443px;
  font-family: "Montserrat", sans-serif;
  font-style: italic;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
}
</style>